import { SettingsDaiCostsResponse } from './types';

/**
 * 購入区分の絞り込みを適用する
 * 空文字・未指定の場合はフィルタリングしない（全件表示）
 */
export const dataDaiCostsFilteredByKonyuKbn = (
  dataDaiCost: SettingsDaiCostsResponse,
  konyuKbnFilter: string | undefined
): SettingsDaiCostsResponse => {
  const trimmed = konyuKbnFilter?.trim() ?? '';
  if (trimmed === '') {
    return dataDaiCost;
  }

  return {
    ...dataDaiCost,
    data: dataDaiCost.data.filter((row) => row.konyuKbn === trimmed),
  };
};
